module.exports = __webpack_public_path__ + "static/media/instagram.bf54079f.svg";